<template>
    <div>test</div>
</template>
<script>
import {evaluatePlatform, getMobileOperatingSystem} from '../utils/helper';

export default {
    name: 'app',
    mounted() {
        const path = this.$route.query.path;
        localStorage.setItem('redirectTo', path);
        if (evaluatePlatform() === 'web' && getMobileOperatingSystem() !== 'unknown') {
            window.location.replace(`mastersclub://${path}`);
        }
        this.$router.push(`/${path}`);
    },
}
</script>